module.exports = __webpack_public_path__ + "img/ne.fe232d8a.svg";